import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class BestLenders {
  private apiUrl = 'https://api.freerateupdate.com/get/bestlender';

  constructor(private http: HttpClient) {}

  public getBestLenders() {
    return this.http.get(this.apiUrl).pipe(
      map((data: any) => data),
      catchError((error) => {
        console.error('BestLenders.getBestLenders failed', error);
        return of([]);
      })
    );
  }
}
